module.exports = __webpack_public_path__ + "static/sample-projects-19-36fc4a6ab2419644a7280f168e638b1d.png";